import http from '@utils/http';

/**
 * GET /api/v1/rbac/roles
 */
export const getRoles = () => http.get('/rbac/roles').then((res) => res.data?.data ?? res.data ?? []);

/**
 * GET /api/v1/rbac/roles/:id
 */
export const getRoleById = (id) => http.get(`/rbac/roles/${id}`).then((res) => res.data?.data ?? res.data);

/**
 * GET /api/v1/rbac/permissions
 */
export const getPermissions = () =>
    http.get('/rbac/permissions').then((res) => {
        const payload = res.data ?? {};
        const inner = payload.data ?? payload;

        const flattenPermissions = (value) => {
            if (!value) return [];
            if (Array.isArray(value)) return value;
            if (typeof value === 'object') {
                const vals = Object.values(value);
                const out = [];
                for (const v of vals) out.push(...flattenPermissions(v));
                return out;
            }
            return [];
        };

        // Backends have returned permissions as: array, {permissions: []}, {permissions: { module: [] }}, { items: [] }, etc.
        const rawPermissions =
            inner.items ??
            inner.data ??
            inner.permissions ??
            (Array.isArray(inner) ? inner : Array.isArray(payload) ? payload : []);
        const permissions = flattenPermissions(rawPermissions);

        const predefinedRoles = Array.isArray(inner.predefinedRoles) ? inner.predefinedRoles : [];

        return { permissions, predefinedRoles };
    });

/**
 * POST /api/v1/rbac/roles
 * @param {{ name: string, permissionIds: string[] }} body
 */
export const createRole = (body) => http.post('/rbac/roles', body).then((res) => res.data?.data ?? res.data);

/**
 * PATCH /api/v1/rbac/roles/:id
 * @param {string} id - role id
 * @param {{ name?: string, permissionIds?: string[] }} body
 */
export const updateRole = (id, body) => http.patch(`/rbac/roles/${id}`, body).then((res) => res.data?.data ?? res.data);

/**
 * DELETE /api/v1/rbac/roles/:id
 */
export const deleteRole = (id) => http.delete(`/rbac/roles/${id}`).then((res) => res.data?.data ?? res.data);
